var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 3.33325L36.6666 36.6666",
    stroke: "#162523",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9167 4.48341C16.9345 3.30478 20.2302 3.0312 23.401 3.69614C26.5717 4.36109 29.4799 5.93571 31.7699 8.22742C34.0598 10.5191 35.6322 13.4285 36.2947 16.5998C36.9572 19.771 36.681 23.0666 35.5001 26.0834",
    stroke: "#162523",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8 31.8C30.2504 33.3495 28.4107 34.5788 26.3861 35.4174C24.3614 36.256 22.1914 36.6877 20 36.6877C17.8085 36.6877 15.6385 36.256 13.6139 35.4174C11.5892 34.5788 9.74957 33.3495 8.19998 31.8C6.65038 30.2504 5.42117 28.4107 4.58253 26.3861C3.7439 24.3614 3.31226 22.1914 3.31226 20C3.31226 17.8085 3.7439 15.6385 4.58253 13.6138C5.42117 11.5892 6.65038 9.74955 8.19998 8.19995",
    stroke: "#162523",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAccess);
export default __webpack_public_path__ + "static/media/no-access.a8e03e9ffc2de02b819b6491dad958a2.svg";
export { ForwardRef as ReactComponent };